import { render, staticRenderFns } from "./PacotesCicloSemestral.vue?vue&type=template&id=7845aeb2&"
import script from "./PacotesCicloSemestral.vue?vue&type=script&lang=js&"
export * from "./PacotesCicloSemestral.vue?vue&type=script&lang=js&"
import style0 from "./PacotesCicloSemestral.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports